import _defineProperty from "@babel/runtime/helpers/defineProperty";
import AkIconCheck from '@atlaskit/icon/glyph/check';
import { FilterClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import { LinkUtils } from '@atlassian/mpac-utils';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../../common/constants/proptypes/CommonPropTypes";
import { TEST_IDS } from "../../../../../../../common/constants/testIds";
import { ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_FILTER } from "../../../../../../constants/analytics/events";
import AddonDiscoveryPropTypes from "../../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import { FacetSidebarItemContainer, Label, TickIcon } from "../../FacetSidebarItem";
class ConjunctiveFacetProduct extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", (event, options) => {
      const facetKey = this.props.facet.get('key');
      const filterValue = this.props.facetProduct.get('value');
      const newIsSelected = !this.props.selected;
      this.props.fireAnalyticsEvent({
        eventType: FilterClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER,
        objectType: OBJECT_TYPE_FILTER,
        objectId: facetKey,
        label: this.props.facetProduct.get('label'),
        parentLabel: this.props.facet.get('sidebarLabel'),
        source: this.props.perspective,
        attributes: {
          sourceComponent: EVENT_SOURCE,
          currentPerspective: this.props.perspective,
          filterValue,
          selected: newIsSelected
        }
      }, EVENT_CHANNEL);
      LinkUtils.maybeOpenInNewTab(event, () => {
        this.props.stateChangeRequested({
          perspective: options.newPerspective,
          filters: options.newFilters
        });
      });
    });
  }
  render() {
    const FiltersLink = this.props.filtersLink;
    const newFilters = this.props.selected ? this.props.filters.delete(this.props.facet.get('key')) : this.props.filters.set(this.props.facet.get('key'), this.props.facetProduct.get('value'));
    return /*#__PURE__*/React.createElement(FacetSidebarItemContainer, {
      selected: this.props.selected,
      "data-testid": TEST_IDS.FILTER_SIDEBAR_ITEM
    }, /*#__PURE__*/React.createElement(TickIcon, null, /*#__PURE__*/React.createElement(AkIconCheck, {
      label: "Selected",
      size: "medium"
    })), /*#__PURE__*/React.createElement(FiltersLink, {
      className: "ui-product",
      filtersContext: this.props.filtersContext,
      newFilters: newFilters,
      onClick: this.onClick
    }, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement("span", null, this.props.facetProduct.get('label')))));
  }
}
_defineProperty(ConjunctiveFacetProduct, "propTypes", {
  fireAnalyticsEvent: PropTypes.func.isRequired,
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  facetProduct: ImmutablePropTypes.map.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  filtersContext: AddonDiscoveryPropTypes.filtersContext,
  filtersLink: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});
export default withAnalytics(ConjunctiveFacetProduct);